/**
 * Inbound bridge: Shopify.actions.updateCart emits shopify:cart:* with
 * context `standard-action`. Convert those into ThemeEvents so the drawer,
 * cart icon, and cart-items morph as they do for theme-owned AJAX.
 *
 * Do not dispatch another shopify:cart:* event here.
 */

import { StandardEvents } from '@shopify/standard-events';
import { CartUpdateEvent } from '@theme/events';
import { sectionRenderer } from '@theme/section-renderer';
import { collectCartSectionIds } from '@theme/standard-events-dispatch';

const STANDARD_ACTION_SOURCE = 'standard-action';

/**
 * @param {Event} event
 */
const handleStandardActionCartEvent = async (event) => {
  if (!('context' in event) || event.context !== 'standard-action') return;
  if (!('promise' in event) || !(event.promise instanceof Promise)) return;

  try {
    const result = await event.promise;
    const sectionIds = collectCartSectionIds();
    /** @type {Record<string, string>} */
    const sections = {};

    await Promise.all(
      sectionIds.map(async (sectionId) => {
        sections[sectionId] = await sectionRenderer.getSectionHTML(sectionId, false);
      })
    );

    const itemCount = result?.cart?.totalQuantity ?? 0;

    document.dispatchEvent(
      new CartUpdateEvent(result?.cart ?? {}, STANDARD_ACTION_SOURCE, {
        itemCount,
        source: STANDARD_ACTION_SOURCE,
        sections,
      })
    );
  } catch {
    // Rejected cart operations already dispatch shopify:cart:error.
  }
};

document.addEventListener(StandardEvents.cartLinesUpdate, handleStandardActionCartEvent);
document.addEventListener(StandardEvents.cartNoteUpdate, handleStandardActionCartEvent);
document.addEventListener(StandardEvents.cartDiscountUpdate, handleStandardActionCartEvent);
